import React, { useEffect, useState } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, ListGroup, ListGroupItem, Button, Tooltip } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFolder, faFile, faFileWord, faFilePdf, faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import fetchMethodRequest from '../../../config/service';
import showToasterMessage from '../../UI/ToasterMessage/toasterMessage';

const MoveFilesModal = (props) => {
    const [initialFilesAndFolders, setInitialFilesAndFolders] = useState({ folders: [], files: [] });
    const [moveFilesResponse, setMoveFilesResponse] = useState({ folders: [], files: [] });
    const [filterCriteria, setFilterCriteria] = useState({ limit: 20, page: 1, criteria: [], sortfield: 'created', direction: 'desc' });
    const [folderId, setFolderId] = useState(null);
    const [destinationPath, setDestinationPath] = useState(null);
    const [breadcrumb, setBreadcrumb] = useState([{ _id: 'home', name: 'Home' }]);
    const [tooltipOpen, setTooltipOpen] = useState({});
    const isHome = breadcrumb.length === 1 && breadcrumb[0].name === 'Home';

    useEffect(() => {
        getInitialFilesAndFoldersData();
    }, []);

    const getInitialFilesAndFoldersData = () => {
        fetchMethodRequest('GET', 'homes')
            .then(async (response) => {
                if (response) {
                    setInitialFilesAndFolders(response);
                    setMoveFilesResponse(response);
                    setFolderId(null);
                    setDestinationPath(null);
                    setBreadcrumb([{ _id: 'home', name: 'Home' }]);
                }
            })
            .catch((error) => {
                console.error('Error fetching initial data:', error);
            });
    };

    const moveFilesAndFolders = (folderId, destinationPath, item) => {
        const selectedRowsId = props.selectedRowsId;
        const fileToMove = selectedRowsId && selectedRowsId.length > 0 ? selectedRowsId[0] : null;
        let url;
        const body = {
            ...fileToMove,
            destParentFolderId: folderId,
            destPath: destinationPath || ""
        };
        if (selectedRowsId && selectedRowsId[0] && selectedRowsId[0].type) {
            url = `files/fileMove/${props.moveFoldersId}`;
        } else {
            url = `folders/moveFolder/${props.moveFoldersId}`;
        }
        fetchMethodRequest("PUT", url, body)
            .then(async (res) => {
                if (res && res.respMessage) {
                    showToasterMessage(res.respMessage, 'success');
                    props.closeDeleteModal();
                    props.getDataFromServer();
                } else {
                    showToasterMessage(res.errorMessage, 'error');
                }
            })
            .catch((err) => {
                console.error("Fetch error:", err);
                showToasterMessage('Error moving files', 'error');
            });
    };

    const getFilesAndFoldersData = (item, filterCriteria) => {
        let url = 'homes';
        if (item && item._id && item.name !== 'Home') {
            filterCriteria['criteria'] = [{ key: "parentFolderId", value: item._id, type: 'eq' }];
            url = `homes?filter=${JSON.stringify(filterCriteria)}`
        }
        fetchMethodRequest('GET', url)
            .then(async (response) => {
                if (response) {
                    setMoveFilesResponse(response);
                    updateBreadcrumb(item);
                }
            })
            .catch((error) => {
                console.error('Error fetching data:', error);
            });
    };

    const updateBreadcrumb = (item) => {
        if (item) {
            const existingIndex = breadcrumb.findIndex(b => b._id === item._id);
            if (existingIndex === -1) {
                const updatedBreadcrumb = [...breadcrumb, item];
                setBreadcrumb(updatedBreadcrumb);
            } else {
                const updatedBreadcrumb = breadcrumb.slice(0, existingIndex + 1);
                setBreadcrumb(updatedBreadcrumb);
            }
        } else {
            setBreadcrumb([{ _id: 'home', name: 'Home' }]);
            setMoveFilesResponse(initialFilesAndFolders);
        }
    };

    const handleFolderClick = (folderId, item) => {
        setFolderId(folderId);
        setDestinationPath(item.path);
        fetchMethodRequest('GET', `folders/${folderId}`)
            .then(async (response) => {
                if (response) {
                    if (breadcrumb.length === 0 || breadcrumb[breadcrumb.length - 1]._id !== item._id) {
                        updateBreadcrumb(item);
                    }
                    getFilesAndFoldersData(item, filterCriteria);
                }
            })
            .catch((error) => {
                console.error('Error fetching folder content:', error);
            });
    };

    const getFileIcon = (fileType) => {
        let icon = faFile;
        let color = 'gray';

        if (fileType === 'doc') {
            icon = faFileWord;
            color = 'rgb(18, 146, 238)';
        } else if (fileType === 'pdf') {
            icon = faFilePdf;
            color = 'red';
        }

        return { icon, color };
    };

    const renderBreadcrumb = () => {
        return (
            <nav aria-label="breadcrumb" className="mb-0 w-100">
                <ol className="breadcrumb mb-0 bg-transparent p-0 flex-nowrap align-items-center">
                    {breadcrumb.map((item, index) => (
                        <li key={item._id} className={`breadcrumb-item ${index === breadcrumb.length - 1 ? 'active' : ''}`} style={{ whiteSpace: 'nowrap' }}>
                            {index === breadcrumb.length - 1 ? (
                                <span style={{ color: '#64748b', fontWeight: 600, fontSize: '10px', letterSpacing: '0.2px' }}>{item.name}</span>
                            ) : (
                                <a href="#" onClick={(event) => handleBreadcrumbClick(event, index)} style={{ color: '#2563eb', textDecoration: 'none', fontWeight: 500, fontSize: '10px', letterSpacing: '0.2px' }}>{item.name}</a>
                            )}
                        </li>
                    ))}
                </ol>
            </nav>
        );
    };

    const renderFolderItems = () => {
        return moveFilesResponse.folders?.map((folder) => (
            (folder.name !== props.selectedRowsId[0]?.name || folder.path !== props.selectedRowsId[0]?.path) && (
                <ListGroupItem
                    key={folder._id}
                    className='d-flex justify-content-between align-items-center border-0'
                    style={{ cursor: 'pointer', transition: 'background-color 0.2s', padding: '6px 8px' }}
                    onClick={() => handleFolderClick(folder._id, folder)}
                    action
                >
                    <div className="d-flex align-items-center text-truncate pr-3">
                        <FontAwesomeIcon icon={faFolder} className="text-warning" style={{ marginRight: '8px', fontSize: '0.9rem' }} />
                        <span className="text-truncate" style={{ fontWeight: 500, color: '#334155', fontSize: '11px', letterSpacing: '0.1px' }}>{folder.name}</span>
                    </div>
                    <Button
                        color="primary"
                        size="sm"
                        className="px-2 py-0"
                        style={{ borderRadius: '20px', fontSize: '10px', fontWeight: 600, backgroundColor: '#12225f', borderColor: '#12225f', whiteSpace: 'nowrap' }}
                        onClick={(e) => {
                            e.stopPropagation();
                            moveFilesAndFolders(folder._id, folder.path, folder);
                        }}
                    >
                        Move
                    </Button>
                </ListGroupItem>
            )
        ));
    };

    const renderFileItems = () => {
        return moveFilesResponse.files?.map((file) => (
            file.name !== props.selectedRowsId[0]?.name && (
                <ListGroupItem
                    key={file._id}
                    className='d-flex align-items-center border-0'
                    id={`file-tooltip-${file._id}`}
                    style={{ cursor: 'not-allowed', opacity: 0.6, padding: '6px 8px' }}
                >
                    <div className="d-flex align-items-center text-truncate">
                        <FontAwesomeIcon icon={getFileIcon(file.type).icon} style={{ color: getFileIcon(file.type).color, marginRight: '8px', fontSize: '0.9rem' }} />
                        <span className="text-truncate text-muted" style={{ fontWeight: 400, fontSize: '11px', letterSpacing: '0.1px' }}>{file.name}</span>
                    </div>
                    <Tooltip
                        placement="top"
                        isOpen={tooltipOpen[`file-tooltip-${file._id}`]}
                        target={`file-tooltip-${file._id}`}
                        toggle={() => toggleTooltip(`file-tooltip-${file._id}`)}
                    >
                        Cannot select {file.name} because it is not a folder
                    </Tooltip>
                </ListGroupItem>
            )
        ));
    };

    const handleBreadcrumbClick = (event, index) => {
        event.preventDefault();

        const item = breadcrumb[index];

        if (item.name === 'Home') {
            setFolderId(null);
            setDestinationPath(null);
            setBreadcrumb([{ _id: 'home', name: 'Home' }]);
            setMoveFilesResponse(initialFilesAndFolders);
            return;
        }

        setFolderId(item._id);
        setDestinationPath(item.path);
        const updatedBreadcrumb = breadcrumb.slice(0, index + 1);
        setBreadcrumb(updatedBreadcrumb);
        getFilesAndFoldersData(item, filterCriteria);
    };

    const toggleTooltip = (id) => {
        setTooltipOpen(prevState => ({
            ...prevState,
            [id]: !prevState[id]
        }));
    };

    const handleBackClick = () => {
        if (breadcrumb.length > 1) {
            const previousItem = breadcrumb[breadcrumb.length - 2];
            setFolderId(previousItem._id);
            setDestinationPath(previousItem.path);
            const updatedBreadcrumb = breadcrumb.slice(0, breadcrumb.length - 1);
            setBreadcrumb(updatedBreadcrumb);
            getFilesAndFoldersData(previousItem, filterCriteria);
        }
    };

    return (
        <Modal isOpen={props.openMoveFolder} toggle={props.closeDeleteModal} className="modal-dialog-centered" size="sm" style={{ maxWidth: '400px', fontFamily: "'Outfit', sans-serif" }}>
            <ModalHeader toggle={props.closeDeleteModal} className="border-0 py-2 px-3" cssModule={{ 'modal-title': 'w-100' }}>
                <div className="d-flex align-items-center">
                    {!isHome && (
                        <FontAwesomeIcon
                            icon={faArrowLeft}
                            onClick={handleBackClick}
                            className="mr-2"
                            style={{ cursor: 'pointer', color: '#12225f', marginRight: '8px', fontSize: '11px' }}
                        />
                    )}
                    <h5 className="mb-0 font-weight-bold" style={{ color: '#1e293b', fontSize: '14px', letterSpacing: '0.2px' }}>
                        {`Move ${props.selectedRowsId[0]?.name}`}
                    </h5>
                </div>
            </ModalHeader>
            <ModalBody className="p-2" style={{ backgroundColor: '#ffffff' }}>
                <div className="mb-2 d-flex align-items-center px-1" style={{ overflowX: 'auto', fontSize: '11px' }}>
                    <span className="mr-2 mt-0" style={{ color: '#94a3b8', fontSize: '9px', textTransform: 'uppercase', letterSpacing: '0.5px', fontWeight: 700, whiteSpace: 'nowrap', marginRight: '8px' }}>
                        Location:
                    </span>
                    <div className='p-0' style={{ flex: 1, minWidth: 0 }}>
                        {renderBreadcrumb()}
                    </div>
                </div>
                <div className="border-top" style={{ height: '280px', overflowY: 'auto' }}>
                    {moveFilesResponse.folders.length === 0 && moveFilesResponse.files.length === 0 ? (
                        <div className="d-flex flex-column justify-content-center align-items-center h-100 text-muted p-3 text-center">
                            <FontAwesomeIcon icon={faFolder} style={{ fontSize: '1.5rem', color: '#cbd5e1', marginBottom: '8px' }} />
                            <h6 className="font-weight-bold mb-1" style={{ color: '#475569', fontSize: '11px', letterSpacing: '0.1px' }}>This Folder is Empty</h6>
                            <p style={{ fontSize: '10px', margin: 0, opacity: 0.8 }}>You can move your file here</p>
                        </div>
                    ) : (
                        <ListGroup flush className="w-100 m-0">
                            {renderFolderItems()}
                            {renderFileItems()}
                        </ListGroup>
                    )}
                </div>
            </ModalBody>
            <ModalFooter className="border-0 py-2 px-3">
                <Button color="secondary" outline size="sm" className="px-2 py-1 font-weight-bold mr-2" style={{ borderRadius: '4px', fontSize: '10px', color: '#64748b', borderColor: '#e2e8f0' }} onClick={props.closeDeleteModal}>
                    Cancel
                </Button>
                <Button color="primary" size="sm" className="px-2 py-1 font-weight-bold" style={{ borderRadius: '4px', backgroundColor: '#2563eb', borderColor: '#2563eb', fontSize: '10px' }} onClick={() => moveFilesAndFolders(folderId, destinationPath, null)}>
                    Move Here
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default MoveFilesModal;
